"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficialMarkedValue = exports.ReportDashboardMetricDefinition = exports.ReportDashboardConfig = exports.ReportDashboardPersistedConfig = exports.ReportDashboardComponentConfig = exports.GetTradeCashFlowsAggregationRequest = exports.AdminBatchProcessRequest = exports.BATCH_PROCESS_ACTION_STATUS = exports.BATCH_PROCESS_ACTION_RESET = exports.BATCH_PROCESS_SYSTEM_ACTION_WARMUP_DB = exports.BATCH_PROCESS_SYSTEM_ACTION_CHECK_DB_AVAILABILITY = exports.GetTradeCashFlowsRequest = exports.GetEODTaskDetails = exports.GetOpeningDataRequest = exports.LiveProfileData = exports.GetFullTransactionResult = exports.GetFullTransactionRequest = exports.GetTransactionDetailsResult = exports.GetTransactionDetailsRequest = exports.BusinessAlerts = exports.BusinessAlertsRequest = exports.PaymentRelease = exports.SecurityBufferAllocation = exports.AccountFlowBreakdown = exports.ExceptionAdminRequest = exports.MatchingReconciliationReport = exports.MatchingReconciliationResult = exports.MatchingReconciliationRequest = exports.MatchingReconciliationCurrencyTolerance = exports.BulkImportResult = exports.BulkImportRequest = exports.GetSecurityPositionDetailOutput = exports.GetSecurityPositionDetailRequest = exports.SecurityPositionDetail = exports.GetQuotesRequest = exports.GetSweepInstructions = exports.SweepInstruction = exports.GetIntradayLadderOutput = exports.IntradayLadderPosition = exports.GetIntradayLadderRequest = exports.GetProjectionRequest = exports.GetHistoricalRequest = exports.RiskDashboardRequest = exports.RiskMetricDataUsageType = exports.GetSurvivalHorizonExplainOutput = exports.GetSurvivalHorizonExplainRequest = exports.GetSurvivalHorizonServiceDataOutput = exports.GetSurvivalHorizonServiceDataRequest = exports.SystemMessage = exports.AllocatedBuffer = exports.ThroughputData = exports.ExplainData = exports.CorrectionData = exports.ProjectionCorrectionData = exports.ContractualFlowData = exports.ProjectionData = exports.ProjectionMonitoringData = exports.SurvivalHorizonData = exports.GetCorrectionsOutput = exports.GetCorrectionsRequest = exports.GetDailyBalanceOutput = exports.GetDailyBalancesRequest = exports.AccountBalanceData = exports.ApplicationConfiguration = exports.GetApplicationConfigurationRequest = exports.WebApiEndpoints = void 0;
const ladder_flow_position_1 = require("./ladder-flow-position");
exports.WebApiEndpoints = {
    GetAvatar: 'avatars',
    SaveAvatar: 'avatars',
    QueryApplicationConfigurations: 'application-configurations',
    QueryCorrections: 'corrections',
    SaveCorrection: 'corrections',
    SaveBalance: 'balances',
    QueryDailyBalance: 'daily-balance',
    QueryBusinessAlerts: 'business-alerts',
    QueryProjection: 'projections',
    QuerySurvivalHorizonExplain: 'survival-horizon-explain',
    QuerySurvivalHorizonPositions: 'survival-horizon-positions',
    QueryRiskData: 'risk-data',
    QueryStressedRiskData: 'stressed-risk-data',
    QueryRiskMetricData: 'risk-metric-data',
    QueryStressedRiskMetricData: 'stressed-risk-metric-data',
    GetCSVs: 'csvs',
    QueryHealthChecks: 'health-checks',
    QueryIntradayLadder: 'intraday-ladder',
    QuerySweepInstructions: 'sweep-instructions',
    QueryQuotes: 'quotes',
    SaveQuote: 'quotes',
    QueryCurves: 'market-data/yield-curve',
    QuerySecurityPositionDetails: 'security-position-details',
    SaveSecurityBufferAllocation: 'security-buffer-allocations',
    QueryTransactionDetails: 'transaction-details',
    QueryFullTransaction: 'full-transaction',
    QueryLiveProfileData: 'live-profile-data',
    QueryHistorical: 'historical',
    QueryOpeningData: 'opening-data',
    QueryEODTaskSummary: 'eod/task/summary',
    QueryEODTaskDetails: 'eod/task/details',
    QueryTradeCashFlows: 'trade/cash-flows',
    Import: 'import',
    BatchAdmin: 'batch/admin',
    BatchQuery: 'batch/query',
    QueryALMMetricData: 'alm/metric-data',
    QueryALMReportQuery: 'alm/report-query',
    QueryReportDashboardData: 'alm/adhoc-query',
    SubmitALMAdhocQuery: 'alm/adhoc-query',
    QueryALMAdhocState: 'alm/adhoc-query/state',
    QueryReportDashboardConfigs: 'reporting/report-dashboard/configs',
    SaveReportDashboardConfig: 'reporting/report-dashboard/configs',
    SaveReportDashboardMetricDefinition: 'reporting/report-dashboard/metric/definitions',
    PreviewReportDashboard: 'reporting/report-dashboard/preview',
    QuerySavedReportDashboard: 'reporting/report-dashboard/view',
    PublishReportDashboardReports: 'reporting/report-dashboard/publish',
    QueryCFPConfigs: 'cfp/configs',
    QueryRecordModifications: 'record-modifications',
    UpdateRecordModifications: 'record-modifications',
    ProcessSimulationData: 'alm/simulation/process-data',
};
class GetApplicationConfigurationRequest {
}
exports.GetApplicationConfigurationRequest = GetApplicationConfigurationRequest;
class ApplicationConfiguration {
}
exports.ApplicationConfiguration = ApplicationConfiguration;
class AccountBalanceData {
}
exports.AccountBalanceData = AccountBalanceData;
class GetDailyBalancesRequest {
}
exports.GetDailyBalancesRequest = GetDailyBalancesRequest;
class GetDailyBalanceOutput {
}
exports.GetDailyBalanceOutput = GetDailyBalanceOutput;
class GetCorrectionsRequest {
}
exports.GetCorrectionsRequest = GetCorrectionsRequest;
class GetCorrectionsOutput {
}
exports.GetCorrectionsOutput = GetCorrectionsOutput;
class SurvivalHorizonData extends ladder_flow_position_1.LadderFlowPosition {
    constructor() {
        super(...arguments);
        this.cumulativeAmount = 0;
        this.bufferAmount = 0;
        this.liquiditySurplus = 0;
        this.liveAmount = 0;
        this.transactionSnapshotAmount = 0;
        this.assumptionSnapshotAmount = 0;
        this.preditionSnapshotAmount = 0;
        this.currencyBalanceSnapshotAmount = 0;
    }
    clone() {
        const clone = Object.assign(new SurvivalHorizonData(), this);
        return clone;
    }
    add(data) {
        if (data) {
            this.inAmount += data.inAmount;
            this.outAmount += data.outAmount;
            this.netAmount += data.netAmount;
            this.cumulativeAmount += data.cumulativeAmount;
            this.bufferAmount += data.bufferAmount;
            this.liquiditySurplus += data.liquiditySurplus;
            this.liveAmount += data.liveAmount;
            this.transactionSnapshotAmount += data.transactionSnapshotAmount;
            this.assumptionSnapshotAmount += data.assumptionSnapshotAmount;
            this.preditionSnapshotAmount += data.preditionSnapshotAmount;
            this.currencyBalanceSnapshotAmount += data.currencyBalanceSnapshotAmount;
        }
    }
    subtract(data) {
        if (data) {
            this.inAmount -= data.inAmount;
            this.outAmount -= data.outAmount;
            this.netAmount -= data.netAmount;
            this.cumulativeAmount -= data.cumulativeAmount;
            this.bufferAmount -= data.bufferAmount;
            this.liquiditySurplus -= data.liquiditySurplus;
            this.liveAmount -= data.liveAmount;
            this.transactionSnapshotAmount -= data.transactionSnapshotAmount;
            this.assumptionSnapshotAmount -= data.assumptionSnapshotAmount;
            this.preditionSnapshotAmount -= data.preditionSnapshotAmount;
            this.currencyBalanceSnapshotAmount -= data.currencyBalanceSnapshotAmount;
        }
    }
}
exports.SurvivalHorizonData = SurvivalHorizonData;
SurvivalHorizonData.SOURCE_LIVE = 'live';
SurvivalHorizonData.SOURCE_TRANSACTION_SNAPSHOT = 'txn-ss';
SurvivalHorizonData.SOURCE_ASSUMPTION_SNAPSHOT = 'ass-ss';
SurvivalHorizonData.SOURCE_PREDICTION_SNAPSHOT = 'prd-ss';
SurvivalHorizonData.SOURCE_CURRENCY_BALANCE_SNAPSHOT = 'cbal-ss';
class ProjectionMonitoringData {
}
exports.ProjectionMonitoringData = ProjectionMonitoringData;
class ProjectionData {
    clone() {
        return Object.assign(new ProjectionData(), this);
    }
}
exports.ProjectionData = ProjectionData;
class ContractualFlowData {
}
exports.ContractualFlowData = ContractualFlowData;
class ProjectionCorrectionData {
}
exports.ProjectionCorrectionData = ProjectionCorrectionData;
class CorrectionData {
}
exports.CorrectionData = CorrectionData;
class ExplainData {
}
exports.ExplainData = ExplainData;
class ThroughputData {
}
exports.ThroughputData = ThroughputData;
class AllocatedBuffer {
}
exports.AllocatedBuffer = AllocatedBuffer;
class SystemMessage {
}
exports.SystemMessage = SystemMessage;
class GetSurvivalHorizonServiceDataRequest {
}
exports.GetSurvivalHorizonServiceDataRequest = GetSurvivalHorizonServiceDataRequest;
class GetSurvivalHorizonServiceDataOutput {
}
exports.GetSurvivalHorizonServiceDataOutput = GetSurvivalHorizonServiceDataOutput;
class GetSurvivalHorizonExplainRequest {
}
exports.GetSurvivalHorizonExplainRequest = GetSurvivalHorizonExplainRequest;
class GetSurvivalHorizonExplainOutput {
}
exports.GetSurvivalHorizonExplainOutput = GetSurvivalHorizonExplainOutput;
var RiskMetricDataUsageType;
(function (RiskMetricDataUsageType) {
    RiskMetricDataUsageType["SINGLE_DAY"] = "SINGLE_DAY";
    RiskMetricDataUsageType["WEEK_DAY_TREND"] = "WEEK_DAY_TREND";
    RiskMetricDataUsageType["MONTH_DAY_TREND"] = "MONTH_DAY_TREND";
    RiskMetricDataUsageType["THIRTY_DAY_TREND"] = "THIRTY_DAY_TREND";
})(RiskMetricDataUsageType = exports.RiskMetricDataUsageType || (exports.RiskMetricDataUsageType = {}));
class RiskDashboardRequest {
}
exports.RiskDashboardRequest = RiskDashboardRequest;
class GetHistoricalRequest {
}
exports.GetHistoricalRequest = GetHistoricalRequest;
class GetProjectionRequest {
}
exports.GetProjectionRequest = GetProjectionRequest;
class GetIntradayLadderRequest {
}
exports.GetIntradayLadderRequest = GetIntradayLadderRequest;
class IntradayLadderPosition {
}
exports.IntradayLadderPosition = IntradayLadderPosition;
class GetIntradayLadderOutput {
}
exports.GetIntradayLadderOutput = GetIntradayLadderOutput;
class SweepInstruction {
}
exports.SweepInstruction = SweepInstruction;
class GetSweepInstructions {
}
exports.GetSweepInstructions = GetSweepInstructions;
class GetQuotesRequest {
}
exports.GetQuotesRequest = GetQuotesRequest;
class SecurityPositionDetail {
}
exports.SecurityPositionDetail = SecurityPositionDetail;
class GetSecurityPositionDetailRequest {
}
exports.GetSecurityPositionDetailRequest = GetSecurityPositionDetailRequest;
class GetSecurityPositionDetailOutput {
}
exports.GetSecurityPositionDetailOutput = GetSecurityPositionDetailOutput;
class BulkImportRequest {
}
exports.BulkImportRequest = BulkImportRequest;
class BulkImportResult {
}
exports.BulkImportResult = BulkImportResult;
class MatchingReconciliationCurrencyTolerance {
}
exports.MatchingReconciliationCurrencyTolerance = MatchingReconciliationCurrencyTolerance;
class MatchingReconciliationRequest {
}
exports.MatchingReconciliationRequest = MatchingReconciliationRequest;
class MatchingReconciliationResult {
}
exports.MatchingReconciliationResult = MatchingReconciliationResult;
class MatchingReconciliationReport {
}
exports.MatchingReconciliationReport = MatchingReconciliationReport;
class ExceptionAdminRequest {
}
exports.ExceptionAdminRequest = ExceptionAdminRequest;
class AccountFlowBreakdown {
}
exports.AccountFlowBreakdown = AccountFlowBreakdown;
class SecurityBufferAllocation {
}
exports.SecurityBufferAllocation = SecurityBufferAllocation;
class PaymentRelease {
}
exports.PaymentRelease = PaymentRelease;
class BusinessAlertsRequest {
}
exports.BusinessAlertsRequest = BusinessAlertsRequest;
class BusinessAlerts {
}
exports.BusinessAlerts = BusinessAlerts;
class GetTransactionDetailsRequest {
}
exports.GetTransactionDetailsRequest = GetTransactionDetailsRequest;
class GetTransactionDetailsResult {
}
exports.GetTransactionDetailsResult = GetTransactionDetailsResult;
class GetFullTransactionRequest {
}
exports.GetFullTransactionRequest = GetFullTransactionRequest;
class GetFullTransactionResult {
}
exports.GetFullTransactionResult = GetFullTransactionResult;
class LiveProfileData {
}
exports.LiveProfileData = LiveProfileData;
class GetOpeningDataRequest {
}
exports.GetOpeningDataRequest = GetOpeningDataRequest;
class GetEODTaskDetails {
}
exports.GetEODTaskDetails = GetEODTaskDetails;
class GetTradeCashFlowsRequest {
}
exports.GetTradeCashFlowsRequest = GetTradeCashFlowsRequest;
exports.BATCH_PROCESS_SYSTEM_ACTION_CHECK_DB_AVAILABILITY = 'CHECK_DB_AVAILABILITY';
exports.BATCH_PROCESS_SYSTEM_ACTION_WARMUP_DB = 'WARMUP_DB';
exports.BATCH_PROCESS_ACTION_RESET = 'RESET';
exports.BATCH_PROCESS_ACTION_STATUS = 'STATUS';
class AdminBatchProcessRequest {
}
exports.AdminBatchProcessRequest = AdminBatchProcessRequest;
class GetTradeCashFlowsAggregationRequest {
}
exports.GetTradeCashFlowsAggregationRequest = GetTradeCashFlowsAggregationRequest;
class ReportDashboardComponentConfig {
}
exports.ReportDashboardComponentConfig = ReportDashboardComponentConfig;
class ReportDashboardPersistedConfig {
}
exports.ReportDashboardPersistedConfig = ReportDashboardPersistedConfig;
class ReportDashboardConfig extends ReportDashboardPersistedConfig {
}
exports.ReportDashboardConfig = ReportDashboardConfig;
class ReportDashboardMetricDefinition extends ReportDashboardPersistedConfig {
}
exports.ReportDashboardMetricDefinition = ReportDashboardMetricDefinition;
class OfficialMarkedValue {
}
exports.OfficialMarkedValue = OfficialMarkedValue;
//# sourceMappingURL=web-api.js.map